import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "reusableComponents/Navbars/DashboardNavbar";
import {useState} from "react";
import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import BatchesPage from "./BatchesPage";

function ManageBatches() {

    const [notification, setNotification] = useState({
        show: false,
        snackbarMessage: "",
        severity: "",
    });

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <BatchesPage setNotification={setNotification}/>

            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
        </DashboardLayout>
    );
};

export default ManageBatches;
